import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import { Link, useLocation } from 'react-router-dom';

const DashboardContainer = styled.div`
  min-height: 100vh;
  background: var(--background);
`;

const Content = styled.div`
  display: flex;
  padding-top: 65px;
`;

const Sidebar = styled.aside`
  width: 260px;
  height: calc(100vh - 65px);
  position: fixed;
  background: var(--surface);
  border-right: 1px solid var(--border);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.05);
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 260px;
  padding: 32px;
  min-height: calc(100vh - 65px);
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  ${props => props.active && `
    color: var(--primary);
    background: var(--primary-light);
    font-weight: 600;
  `}

  &:hover {
    color: var(--primary);
    background: var(--surface-hover);
    transform: translateX(4px);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: var(--primary);
    opacity: 0;
    transition: opacity 0.2s;
  }

  ${props => props.active && `
    &::before {
      opacity: 1;
    }
  `}
`;

const Icon = styled.span`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const NavLabel = styled.span`
  flex: 1;
`;

const Badge = styled.span`
  background: ${props => props.active ? 'var(--primary)' : 'var(--count-badge)'};
  color: ${props => props.active ? 'white' : 'var(--text-secondary)'};
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

const UserSection = styled.div`
  margin-top: auto;
  padding: 16px;
  background: var(--surface-hover);
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
`;

const UserInfo = styled.div`
  flex: 1;
`;

const UserName = styled.div`
  font-weight: 600;
  color: var(--text-primary);
`;

const UserEmail = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <DashboardContainer>
      <Header />
      <Content>
        <Sidebar>
          <NavItem to="/dashboard" active={isActive('/dashboard')}>
            <Icon>📊</Icon>
            <NavLabel>Dashboard</NavLabel>
          </NavItem>
          <NavItem to="/subscriptions" active={isActive('/subscriptions')}>
            <Icon>💳</Icon>
            <NavLabel>Subscriptions</NavLabel>
          </NavItem>
          <NavItem to="/payment-methods" active={isActive('/payment-methods')}>
            <Icon>💰</Icon>
            <NavLabel>Payment Methods</NavLabel>
          </NavItem>
          <NavItem to="/tags" active={isActive('/tags')}>
            <Icon>🏷️</Icon>
            <NavLabel>Tags</NavLabel>
          </NavItem>
          

          
        </Sidebar>
        <MainContent>
          {children}
        </MainContent>
      </Content>
    </DashboardContainer>
  );
};

export default DashboardLayout; 